import React from "react";
import Navigation from "../Navigation";
import Header from "../Header";
import Footer from "../Footer";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

const Disconnect = () => (
  <div>
    <Navigation />
    <Header>
      <div className="heading text-uppercase">Disconnected</div>
    </Header>
    <section className="page-section" id="disconnect">
      <Container>
        <Row>
          <Col lg={{ span: 8, offset: 2 }} className="text-center">
            <h2 className="section-heading text-uppercase">QvirtAdmin Disconnected</h2>
            <p style={{ fontSize: "18px", marginTop: "30px" }}>
              You have successfully disconnected QvirtAdmin from your QuickBooks Online account.
              Your QuickBooks data is no longer accessed by Qvirt.
            </p>
            <p style={{ fontSize: "18px", marginTop: "20px" }}>
              If you reconnect QvirtAdmin in the future, you will be asked to authorize access again.
            </p>
            <p style={{ fontSize: "18px", marginTop: "40px" }}>
              Questions? Contact us at{" "}
              <a href="mailto:derekja@qvirt.com">derekja@qvirt.com</a>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
    <Footer />
  </div>
);

export default Disconnect;
